import { render, staticRenderFns } from "./ManageStaging.vue?vue&type=template&id=004f4ece&scoped=true&"
import script from "./ManageStaging.vue?vue&type=script&lang=js&"
export * from "./ManageStaging.vue?vue&type=script&lang=js&"
import style0 from "./ManageStaging.vue?vue&type=style&index=0&id=004f4ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004f4ece",
  null
  
)

export default component.exports